const admin = {
  title: "Development Log",
  subtitle: "System overview and component registry",
  breadcrumbDashboard: "Dashboard",
  breadcrumbAdmin: "Admin Workspace",
  lastUpdated: "Last updated",
  branch: "Branch",
  activePages: "Active Pages",
  placeholderPages: "Placeholder",
  components: "Components",
  fieldsMapped: "Fields Mapped",
  widgetsLabel: "Widgets",
  contextsLabel: "Contexts",
  phaseProgress: "Phase Progress",
  phase1: "Phase 1 — Foundation",
  phase2: "Phase 2 — Editor",
  phase3: "Phase 3 — Story Map",
  phase4: "Phase 4 — AI Hub",
  phase5: "Phase 5 — Extras",
  tabRoutes: "Pages & Routes",
  tabWidgets: "Widgets",
  tabContexts: "Contexts",
  filterPhase: "Phase",
  filterStatus: "Status",
  filterAll: "All",
  dashboardRoutes: "Dashboard Routes",
  standalonePages: "Standalone Pages",
  visible: "Visible",
  hidden: "Hidden",
  sidebar: "Sidebar",
  statusActive: "Active",
  statusPlaceholder: "Placeholder",
  statusComingSoon: "Coming Soon",
  statusDeprecated: "Deprecated",
  architectureStack: "Architecture Stack",
  tabChangelog: "Changelog",
  tabStoryMap: "Story Map",
  changelogTitle: "Changelog & Tracking",
  committedChanges: "Committed Changes",
  uncommittedChanges: "Uncommitted Changes",
  untrackedFiles: "New Files",
  modifiedFiles: "Modified Files",
  dataCcIdSystem: "data-cc-id System",
  dataCcIdExplanation: "Unique identifiers on UI elements enabling dynamic style overrides via StyleOverrideContext. Every element with data-cc-id can be customized in Settings.",
  dataCcIdTextExplanation: "Elements with data-cc-text=\"true\" are also editable for text content.",
  totalIds: "Total IDs",
  textEditableIds: "Text-Editable",
  filesWithIds: "Files with IDs",
  featureStatus: "Feature Status",
  working: "Working",
  notVerified: "Not Verified",
  broken: "Broken",
  committed: "Committed",
  uncommitted: "Uncommitted",
  feature: "Feature",
  status: "Status",
  files: "Files",
  notes: "Notes",
  commitHash: "Commit",
  directLink: "Direct Link",
  searchChangelog: "Search changelog",
  searchPlaceholder: "Search feature, file, commit...",
  directMatches: "Direct Matches",
  relatedConnected: "Related & Connected",
  noSearchResults: "No results found",
  architectureDiagram: "Architecture Map",
  diagramLoading: "Loading diagram...",
  commitButton: "Commit Changes",
  deployButton: "Deploy to Production",
  commitPlaceholder: "Describe your changes...",
  commitSuccess: "Commit successful",
  commitError: "Commit failed",
  deploySuccess: "Deploy successful",
  deployError: "Deploy failed",
  devOnly: "Dev Only",
  enterCommitMessage: "Enter commit message",
  confirmDeploy: "Are you sure? This will commit & push to main",
  loadingGit: "Loading git status...",
  gitError: "Failed to load git status",
  liveStatus: "Live Status",
  pushing: "Pushing...",
  committing: "Committing...",
  nothingToCommit: "Nothing to commit",
  // Workflow statuses
  wfInbox: "Inbox",
  wfWishlist: "Wishlist",
  wfTodo: "To Do",
  wfNext: "Next",
  wfInProgress: "In Progress",
  wfHold: "On Hold",
  wfStuck: "Stuck",
  wfFreeze: "Frozen",
  wfComplete: "Complete",
  wfCancelled: "Cancelled",
  // Sort
  sortBy: "Sort by",
  sortDate: "Date",
  sortName: "Name",
  sortPhase: "Phase",
  sortWorkflow: "Workflow",
  sortFileCount: "File Count",
  // Group
  groupBy: "Group by",
  groupNone: "None",
  groupWorkflow: "Workflow",
  groupPhase: "Phase",
  groupDate: "Date",
  groupFileDir: "File Dir",
  // Filter
  filterWorkflow: "Workflow",
  filterTechStatus: "Tech Status",
  workflowStatus: "Workflow Status",
  noPhase: "No Phase",
  // Dev Checklist
  devChecklist: "Dev Checklist",
  devChecklistTitle: "Dev Checklist — Feature Completion",
  checklistDone: "Checklist Done",
  checklistItemsDone: "Items Done",
  noChecklist: "No checklist",
  reviewedBy: "Reviewed by",
  clGuideContent: "Guide Content",
  clUsageDoc: "Usage Doc",
  clDiagram: "Diagram",
  clAiSourceOfTruth: "AI Source of Truth",
  clConflictReview: "Conflict Review",
  clGuideContentDesc: "data-cc-id + styleOverrideRegistry + i18n",
  clUsageDocDesc: "Comprehensive purpose + notes",
  clDiagramDesc: "connectedTo populated, appears in Mermaid",
  clAiSourceOfTruthDesc: "Comprehensive purpose, CLAUDE.md reference",
  clConflictReviewDesc: "Checked dependencies, contexts, localStorage, events",
  auditLinkTitle: "Code Audit — Multi-Hat Review",
  auditLinkSubtitle: "4 hats · plan · reality · quality · integrity",
  layerKnowledge: "Knowledge",
  layerAutomation: "Automation",
  layerMessaging: "Messaging",
  whyBuilt: "Why it was built",
  connectedToLabel: "Connected to:",
  moreFiles: "files",
  results: "results",
  phaseLabel: "Phase",
  hasRoute: "has route",
  noRoute: "no route",
  connectedToLegend: "connected to",
  routeVisible: "Visible",
  routeHidden: "Hidden",
  routeSidebar: "Sidebar",
  routeComponents: "Components",
  routeContexts: "Contexts:",
  routeTables: "Tables:",
  smStories: "Stories",
  smDone: "Done",
  smMissing: "Missing",
  smBroken: "Broken",
  smCriticalRisks: "Critical Risks",
  smComplete: "Complete",
  smUserJourney: "User Journey",
  smReleaseTiers: "Release Tiers",
  smRisksTimeline: "Risks + Timeline",
  smStatusDone: "Done",
  smStatusBroken: "Broken",
  smStatusMissing: "Missing",
  smStatusUntested: "Untested",
  smRiskLow: "Low",
  smRiskMedium: "Medium",
  smRiskHigh: "High",
  smRiskCritical: "Critical",
  smEmotion: "Emotion",
  smFriction: "Friction",
  smAha: "Aha!",
  smThStory: "Story",
  smThStatus: "Status",
  smThRisk: "Risk",
  smThFile: "File",
  smThTask: "Task",
  smThEffort: "Effort",
  smUnhappyPaths: "Unhappy Paths",
  smTasks: "tasks",
  smRiskMatrix: "Risk Matrix",
  smRiskCol: "Risk",
  smType: "Type",
  smLevel: "Level",
  smMitigation: "Mitigation",
  smImplSequence: "Implementation Sequence",
  smMlpSubtitle: "The Product Users Love",
  smMlpKpis: "KPIs: Daily active usage >80%, Document creation <2min, AI sessions >10/week/user, Satisfaction >4/5",
  smVerificationTitle: "Verification Per Tier",
  smVerifyWs: "Login → dashboard renders → projects visible",
  smVerifyMvp: "All 12 pages work, CRUD on all tables, AI streams, realtime syncs",
  smVerifyMlp: "Full user journey without demo data, all integrations live, satisfaction survey >4/5",
  wfLabelInbox: "Inbox",
  wfLabelWishlist: "Wishlist",
  wfLabelTodo: "To Do",
  wfLabelNext: "Next",
  wfLabelInProgress: "In Progress",
  wfLabelHold: "Hold",
  wfLabelStuck: "Stuck",
  wfLabelFreeze: "Frozen",
  wfLabelComplete: "Complete",
  wfLabelCancelled: "Cancelled",
} as const;
export default admin;
